import setAgentPreferences from 'actions/agent_preferences/set_agent_preferences';

export default class ToggleCustomizeChannelNotificationSounds {
  constructor(context) {
    this.context = context;
  }

  run() {
    const preferences = this.context.stores.agentPreferences.get();
    preferences.toggleCustomizeChannelNotificationSounds();
    setAgentPreferences(this.context, preferences);
  }
}
